export const CHUNKING_STRATEGIES = [
  { labelKey: 'SEMANTIC', defaultLabel: 'Semantic (Recommended)', value: 'semantic' },
  { labelKey: 'RECURSIVE', defaultLabel: 'Recursive', value: 'recursive' },
  { labelKey: 'MARKDOWN', defaultLabel: 'Markdown', value: 'markdown' },
  { labelKey: 'CHARACTER', defaultLabel: 'Character', value: 'character' },
] as const;

export const EMBEDDING_MODEL_ORDER: Record<string, number> = {
  'text-embedding-3-large': 1,
  'text-embedding-3-small': 2,
  'text-embedding-ada-002': 3,
};

export const EMBEDDING_MODEL_LABELS: Record<string, { labelKey: string; defaultLabel: string }> = {
  'text-embedding-3-large': { labelKey: 'TEXT_EMBEDDING_3_LARGE', defaultLabel: 'Text Embedding 3 Large' },
  'text-embedding-3-small': { labelKey: 'TEXT_EMBEDDING_3_SMALL', defaultLabel: 'Text Embedding 3 Small' },
  'text-embedding-ada-002': { labelKey: 'TEXT_EMBEDDING_ADA_002', defaultLabel: 'Text Embedding ADA 002' },
};

export const PAGE_SIZE = 10;

/** Poll knowledges list after re-embed/upload until status settles or timeout. */
export const REEMBED_POLL_INTERVAL_MS = 5_000;
export const REEMBED_POLL_TIMEOUT_MS = 2 * 60_000;
